// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ViewListing-space1-YfDPJ {
	margin-bottom: 6px !important;
}

.ViewListing-space2-PajrY {
	margin-bottom: 12px !important;
}

.ViewListing-space3-Yq_oO {
	margin-bottom: 18px !important;
}

.ViewListing-space4-Gd2qy {
	margin-bottom: 24px !important;
}

.ViewListing-space5-Ccatq {
	margin-bottom: 30px !important;
}

.ViewListing-space6-jvdeI {
	margin-bottom: 36px !important;
}

.ViewListing-space7-I0bpA {
	margin-bottom: 42px !important;
}

.ViewListing-spaceTop8-JMMMS {
	margin-bottom: 48px !important;
}

.ViewListing-spaceTop1-lUohg {
	margin-top: 6px !important;
}

.ViewListing-spaceTop2-wpEcC {
	margin-top: 12px !important;
}

.ViewListing-spaceTop3-G9MbV {
	margin-top: 18px !important;
}

.ViewListing-spaceTop4-x2Bx5 {
	margin-top: 24px !important;
}

.ViewListing-spaceTop5-Mcuvc {
	margin-top: 30px !important;
}

.ViewListing-spaceTop6-tHCby {
	margin-top: 36px !important;
}

.ViewListing-spaceTop7-BgrJA {
	margin-top: 42px !important;
}

.ViewListing-spaceTop8-JMMMS {
	margin-top: 48px !important;
}

.ViewListing-noMargin-yaamJ {
	margin: 0px !important;
}

.ViewListing-padding1-SNPZw {
	padding-bottom: 6px !important;
}

.ViewListing-padding2-qJuAY {
	padding-bottom: 12px !important;
}

.ViewListing-padding3-trS80 {
	padding-bottom: 18px !important;
}

.ViewListing-padding4-QXKn8 {
	padding-bottom: 24px !important;
}

.ViewListing-padding5-jdMiO {
	padding-bottom: 30px !important;
}

.ViewListing-padding6-Kaqaw {
	padding-bottom: 36px !important;
}

.ViewListing-padding7-OOd0f {
	padding-bottom: 42px !important;
}

.ViewListing-paddingTop1-GM3b3 {
	padding-top: 6px !important;
}

.ViewListing-paddingTop2-ZcGvJ {
	padding-top: 12px !important;
}

.ViewListing-paddingTop3-USvES {
	padding-top: 18px !important;
}

.ViewListing-paddingTop4-b0Pxe {
	padding-top: 24px !important;
}

.ViewListing-paddingTop5-WCSIu {
	padding-top: 30px !important;
}

.ViewListing-paddingTop6-yFbT1 {
	padding-top: 36px !important;
}

.ViewListing-paddingTop7-p1Mfn {
	padding-top: 42px !important;
}

.ViewListing-noPadding-wz8Rz {
	padding: 0px !important;
}

.ViewListing-textBold-bQ8aE {
	font-weight: 500 !important;
}

.ViewListing-textBolder-BOXzk {
	font-weight: 700 !important;
}

.ViewListing-textNormal-XfJru {
	font-weight: normal !important;
}

.ViewListing-spaceBottom20-Y7w_R {
	margin-bottom: 20px;
}

.ViewListing-spaceBottom10-vchNm {
	margin-bottom: 10px;
}

.ViewListing-marginNone-fxpem {
	margin: 0;
}

.ViewListing-spaceBottom15-zTh3k {
	margin-bottom: 15px;
}

.ViewListing-marginTopNone-VTQHM {
	margin-top: 0;
}

.ViewListing-spaceTop11-idYzr {
	margin-top: 11px;
}

.ViewListing-spaceTop21-jZT3F {
	margin-top: 21px;
}

.ViewListing-spaceTop20-HCItB {
	margin-top: 20px;
}

.ViewListing-spaceTop10-JE3m8 {
	margin-top: 10px;
}

/*New Design Text Colors */

.ViewListing-textDarkBlue-sarDD {
	color: rgb(20, 39, 94) !important;
}

.ViewListing-textLightBlue-DZ6cG {
	color: rgb(57, 87, 106) !important;
}

.ViewListing-textLightSandleGreen-NoVXa {
	color: rgb(76, 86, 41) !important;
}

.ViewListing-textLightBrown-Rcd6a {
	color: rgb(115, 79, 33) !important;
}

.ViewListing-textMediumMaroon-JL8r6 {
	color: rgb(87, 37, 51) !important;
}

.ViewListing-textBrown-HZi_Q {
	color: rgb(160, 47, 24) !important;
}

.ViewListing-textMaroon-IxQ40 {
	color: rgb(155, 49, 67) !important;
}

.ViewListing-textDarkBrown-AUrtZ {
	color: rgb(83, 18, 16) !important;
}

.ViewListing-textMediumBrown-JxUUj {
	color: rgb(142, 28, 10) !important;
}

.ViewListing-textSkyBlue-veTWH {
	color: rgb(37, 117, 141) !important;
}

.ViewListing-textGray-QbcYf {
	color: rgb(77, 65, 51) !important;
}

.ViewListing-root-DTWn_ {
	padding-left: 0px;
	padding-right: 0px;
}

.ViewListing-container-sUPB7 {
	margin: 0 auto;
	padding: 0px;
	margin-top: 0px;
}

.ViewListing-pageContainer-S945X {
	display: block;
	height: 100%;
	width: 100%;
}

.ViewListing-pageContent-uF7st {
	max-width: 1274px;
	position: relative;
	display: block;
	margin: 0px auto;
	padding: 0px 15px;
}

.ViewListing-horizontalLineThrough-zQ0oL {
	position: relative;
	display: block;
	margin-top: 30px;
}

.ViewListing-paddingTop2-ZcGvJ {
	padding-top: 12px;
}

.ViewListing-noPadding-wz8Rz {
	padding: 0px;
}

.ViewListing-positionSticky-dhZW3 {
	position: sticky !important;
	top: 83px;
	padding-right: 0;
	z-index: 2;
}

.ViewListing-similarPadding-YMK_A {
	padding-bottom: 20px;
}

.ViewListing-similarPaddingText-oVZDs {
	padding: 0px;
}

.ViewListing-showAffix-_rm81 {
	display: block;
}

a {
	color: var(--primary-link-foreground);
}

.ViewListing-textColor-E5O7H {
	color: var(--secondary-bg);
	text-decoration: none;
	-webkit-appearance: none;
	   -moz-appearance: none;
	        appearance: none;
	background: transparent;
	border: 0px;
	cursor: pointer;
	padding: p;
	max-width: var(--max-container-width);
	margin: 0 auto
}

.ViewListing-displayTable-K5UAz {
	display: table;
	width: 100%;
}

.ViewListing-displayTableCell-l3rqV {
	display: table-cell;
	width: 100%;
	vertical-align: middle;
}

.ViewListing-sectionTitleText-oQbHh {
	font-size: 24px;
	font-weight: bold;
}

.ViewListing-stickyBookButton-FmtQM {
	display: none;
}

.ViewListing-filtersFooter-ATPVv {
	position: fixed !important;
	bottom: 0px !important;
	left: 0px !important;
	right: 0px !important;
	z-index: 4;
}

.ViewListing-filtersContainer-IdsfO {
	background-color: var(--background-primary) !important;
	padding-top: 16px !important;
	padding-bottom: 16px !important;
	z-index: 5 !important;
	border-top: 1px solid var(--primary-border) !important;
	-webkit-box-shadow: 0px 0px 4px 1px var(--primary-box-shadow);
	        box-shadow: 0px 0px 4px 1px var(--primary-box-shadow);
}

.ViewListing-footerContainer-du_wS {
	margin-left: auto !important;
	margin-right: auto !important;
	width: auto !important;
	padding-right: 24px !important;
	padding-left: 24px !important;
}

.ViewListing-bookItPriceAmount-1EDpF {
	display: inline-block;
}

.ViewListing-bookItPrice-Auv2w {
	word-wrap: break-word;
	font-size: 22px;
	line-height: 26px;
	letter-spacing: normal;
	margin: 0px;
}

.ViewListing-bookItNight-mxHRY {
	font-size: 14px;
}

.ViewListing-fullWidth-pzJO1 {
	width: 100%;
}

.ViewListing-btn-NR3vM {
	font-size: 14px;
}

.ViewListing-reviewSection-zDVDq {
	display: inline-block;
	float: left;
	padding-right: 5px;
}

.ViewListing-noBorder-Vtiau {
	border: 0px !important;
}

.ViewListing-instantIcon-RYNzP {
	color: var(--instantIcon-bg);
	position: relative;
	height: 22px;
	width: 22px;
}

.ViewListing-similarPaddingText-oVZDs h2 {
	margin: 0 0 25px 0;
}

.ViewListing-viewListingLoder-mmr9h {
	min-height: 700px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
}

.ViewListing-viewListingMobileViewBook-MFniJ {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-box-pack: justify;
	    -ms-flex-pack: justify;
	        justify-content: space-between;
	gap: 10px;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
}

.ViewListing-scrollAffixBarListWrapper-H3zxG {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	padding: 20px 15px;
	border-bottom: 1px solid var(--primary-border);
	gap: 10px;
	list-style: none;
	background-color: var(--background-primary);
}

.ViewListing-autoAffixBarList-XjiAv,
.ViewListing-autoAffixBarList-XjiAv:hover,
.ViewListing-autoAffixBarList-XjiAv:focus {
	color: var(--secondary-bg);
}

.ViewListing-autoAffixBarList-XjiAv {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 10px;
	font-size: 16px;
	line-height: 24px;
	font-weight: 500;
}

.ViewListing-autoAffixBarList-XjiAv::after {
	content: '';
	display: block;
	width: 5px;
	height: 5px;
	background-color: var(--primary-foreground);
	border-radius: 50%;
}

.ViewListing-scrollAffixBarListWrapper-H3zxG>li:last-child .ViewListing-autoAffixBarList-XjiAv::after {
	display: none;
}

.ViewListing-isActiveAutoAffixBarList-oZW6G,
.ViewListing-isActiveAutoAffixBarList-oZW6G:hover,
.ViewListing-isActiveAutoAffixBarList-oZW6G:focus {
	color: var(--primary-foreground);
	font-weight: 600;
}

@media (min-width:1200px) {
	.ViewListing-activeStickyBar-VpsPg {
		position: sticky;
		top: 0;
		z-index: 5;
		visibility: visible;
	}

	.ViewListing-nonActiveStickyBar-_r_JJ {
		visibility: hidden;
		height: 0;
		width: 0;
	}

	.ViewListing-activeStickyBarWrapper-vQw2I {
		margin-top: -65px;
	}
}

@media (max-width:1199px) {

	.ViewListing-activeStickyBar-VpsPg,
	.ViewListing-nonActiveStickyBar-_r_JJ {
		display: none;
	}
}

@media (max-width: 1200px) and (min-width: 992px) {

	.ViewListing-similarPaddingText-oVZDs h2 {
		margin-bottom: 20px;
	}
}

@media screen and (max-width: 991px) {
	.ViewListing-sliderMargin-VkfEI {
		padding-bottom: 70px;
		margin-bottom: 30px;
	}

	.ViewListing-similarPaddingText-oVZDs h2 {
		margin-bottom: 20px;
	}

}

@media screen and (max-width: 767px) {
	.ViewListing-listingIntroSection-Jmukh {
		padding-top: 0px;
		margin-top: 0;
	}

	.ViewListing-sliderMargin-VkfEI {
		padding-bottom: 100px;
	}

	.ViewListing-stickyBookButton-FmtQM {
		display: block;
	}

	.ViewListing-displayBlockMobile-FWQHT {
		display: block;
	}

	.ViewListing-displayTableMobile-ZhiWf {
		width: auto;
	}

	.ViewListing-webDevice-mghDG {
		display: block !important;
	}

	.ViewListing-filtersFooter-ATPVv {
		width: 100%;
		display: block;
	}

	.ViewListing-similarPaddingText-oVZDs h2 {
		margin-bottom: 20px;
	}

	.ViewListing-loaderMobileView-FrNgc {
		min-height: 100vh;
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-align: center;
		    -ms-flex-align: center;
		        align-items: center;
		-webkit-box-pack: center;
		    -ms-flex-pack: center;
		        justify-content: center;
	}
}

@media screen and (min-width: 641px) {
	.ViewListing-webDevice-mghDG {
		display: block !important;
	}
}

@media screen and (max-width: 355px) {
	.ViewListing-responsiveNopadding-jH_lx {
		padding: 0px !important;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/routes/viewListing/ViewListing.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC1NA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,YAAY;CACZ,eAAe;AAChB;;AAEA;CACC,cAAc;CACd,YAAY;CACZ,WAAW;AACZ;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;CAClB,cAAc;CACd,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,YAAY;AACb;;AAEA;CAEC,2BAA2B;CAC3B,SAAS;CACT,gBAAgB;CAChB,UAAU;AACX;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,qCAAqC;AACtC;;AAEA;CACC,0BAA0B;CAC1B,qBAAqB;CACrB,wBAAgB;IAAhB,qBAAgB;SAAhB,gBAAgB;CAChB,uBAAuB;CACvB,WAAW;CACX,eAAe;CACf,UAAU;CACV,qCAAqC;CACrC;AACD;;AAEA;CACC,cAAc;CACd,WAAW;AACZ;;AAEA;CACC,mBAAmB;CACnB,WAAW;CACX,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,0BAA0B;CAC1B,sBAAsB;CACtB,oBAAoB;CACpB,qBAAqB;CACrB,UAAU;AACX;;AAEA;CACC,sDAAsD;CACtD,4BAA4B;CAC5B,+BAA+B;CAC/B,qBAAqB;CACrB,sDAAsD;CACtD,6DAAqD;SAArD,qDAAqD;AACtD;;AAEA;CACC,4BAA4B;CAC5B,6BAA6B;CAC7B,sBAAsB;CACtB,8BAA8B;CAC9B,6BAA6B;AAC9B;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;CACrB,eAAe;CACf,iBAAiB;CACjB,sBAAsB;CACtB,WAAW;AACZ;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,qBAAqB;CACrB,WAAW;CACX,kBAAkB;AACnB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,4BAA4B;CAC5B,kBAAkB;CAClB,YAAY;CACZ,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,iBAAiB;CACjB,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;CACvB,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;AACpB;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,yBAA8B;KAA9B,sBAA8B;SAA9B,8BAA8B;CAC9B,SAAS;CACT,mBAAe;KAAf,eAAe;AAChB;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,kBAAkB;CAClB,8CAA8C;CAC9C,SAAS;CACT,gBAAgB;CAChB,2CAA2C;AAC5C;;AAEA;;;CAGC,0BAA0B;AAC3B;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,SAAS;CACT,eAAe;CACf,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,cAAc;CACd,UAAU;CACV,WAAW;CACX,2CAA2C;CAC3C,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;;;CAGC,gCAAgC;CAChC,gBAAgB;AACjB;;AAEA;CACC;EACC,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,mBAAmB;CACpB;;CAEA;EACC,kBAAkB;EAClB,SAAS;EACT,QAAQ;CACT;;CAEA;EACC,iBAAiB;CAClB;AACD;;AAEA;;CAEC;;EAEC,aAAa;CACd;AACD;;AAEA;;CAEC;EACC,mBAAmB;CACpB;AACD;;AAEA;CACC;EACC,oBAAoB;EACpB,mBAAmB;CACpB;;CAEA;EACC,mBAAmB;CACpB;;AAED;;AAGA;CACC;EACC,gBAAgB;EAChB,aAAa;CACd;;CAEA;EACC,qBAAqB;CACtB;;CAEA;EACC,cAAc;CACf;;CAEA;EACC,cAAc;CACf;;CAEA;EACC,WAAW;CACZ;;CAEA;EACC,yBAAyB;CAC1B;;CAEA;EACC,WAAW;EACX,cAAc;CACf;;CAEA;EACC,mBAAmB;CACpB;;CAEA;EACC,iBAAiB;EACjB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;CACxB;AACD;;AAGA;CACC;EACC,yBAAyB;CAC1B;AACD;;AAEA;CACC;EACC,uBAAuB;CACxB;AACD","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}","@import '../../components/helpers.css';\n\n.root {\n\tpadding-left: 0px;\n\tpadding-right: 0px;\n}\n\n.container {\n\tmargin: 0 auto;\n\tpadding: 0px;\n\tmargin-top: 0px;\n}\n\n.pageContainer {\n\tdisplay: block;\n\theight: 100%;\n\twidth: 100%;\n}\n\n.pageContent {\n\tmax-width: 1274px;\n\tposition: relative;\n\tdisplay: block;\n\tmargin: 0px auto;\n\tpadding: 0px 15px;\n}\n\n.horizontalLineThrough {\n\tposition: relative;\n\tdisplay: block;\n\tmargin-top: 30px;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px;\n}\n\n.noPadding {\n\tpadding: 0px;\n}\n\n.positionSticky {\n\tposition: -webkit-sticky;\n\tposition: sticky !important;\n\ttop: 83px;\n\tpadding-right: 0;\n\tz-index: 2;\n}\n\n.similarPadding {\n\tpadding-bottom: 20px;\n}\n\n.similarPaddingText {\n\tpadding: 0px;\n}\n\n.showAffix {\n\tdisplay: block;\n}\n\na {\n\tcolor: var(--primary-link-foreground);\n}\n\n.textColor {\n\tcolor: var(--secondary-bg);\n\ttext-decoration: none;\n\tappearance: none;\n\tbackground: transparent;\n\tborder: 0px;\n\tcursor: pointer;\n\tpadding: p;\n\tmax-width: var(--max-container-width);\n\tmargin: 0 auto\n}\n\n.displayTable {\n\tdisplay: table;\n\twidth: 100%;\n}\n\n.displayTableCell {\n\tdisplay: table-cell;\n\twidth: 100%;\n\tvertical-align: middle;\n}\n\n.sectionTitleText {\n\tfont-size: 24px;\n\tfont-weight: bold;\n}\n\n.stickyBookButton {\n\tdisplay: none;\n}\n\n.filtersFooter {\n\tposition: fixed !important;\n\tbottom: 0px !important;\n\tleft: 0px !important;\n\tright: 0px !important;\n\tz-index: 4;\n}\n\n.filtersContainer {\n\tbackground-color: var(--background-primary) !important;\n\tpadding-top: 16px !important;\n\tpadding-bottom: 16px !important;\n\tz-index: 5 !important;\n\tborder-top: 1px solid var(--primary-border) !important;\n\tbox-shadow: 0px 0px 4px 1px var(--primary-box-shadow);\n}\n\n.footerContainer {\n\tmargin-left: auto !important;\n\tmargin-right: auto !important;\n\twidth: auto !important;\n\tpadding-right: 24px !important;\n\tpadding-left: 24px !important;\n}\n\n.bookItPriceAmount {\n\tdisplay: inline-block;\n}\n\n.bookItPrice {\n\tword-wrap: break-word;\n\tfont-size: 22px;\n\tline-height: 26px;\n\tletter-spacing: normal;\n\tmargin: 0px;\n}\n\n.bookItNight {\n\tfont-size: 14px;\n}\n\n.fullWidth {\n\twidth: 100%;\n}\n\n.btn {\n\tfont-size: 14px;\n}\n\n.reviewSection {\n\tdisplay: inline-block;\n\tfloat: left;\n\tpadding-right: 5px;\n}\n\n.noBorder {\n\tborder: 0px !important;\n}\n\n.instantIcon {\n\tcolor: var(--instantIcon-bg);\n\tposition: relative;\n\theight: 22px;\n\twidth: 22px;\n}\n\n.similarPaddingText h2 {\n\tmargin: 0 0 25px 0;\n}\n\n.viewListingLoder {\n\tmin-height: 700px;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n}\n\n.viewListingMobileViewBook {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tgap: 10px;\n\tflex-wrap: wrap;\n}\n\n.scrollAffixBarListWrapper {\n\tdisplay: flex;\n\talign-items: center;\n\tpadding: 20px 15px;\n\tborder-bottom: 1px solid var(--primary-border);\n\tgap: 10px;\n\tlist-style: none;\n\tbackground-color: var(--background-primary);\n}\n\n.autoAffixBarList,\n.autoAffixBarList:hover,\n.autoAffixBarList:focus {\n\tcolor: var(--secondary-bg);\n}\n\n.autoAffixBarList {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 10px;\n\tfont-size: 16px;\n\tline-height: 24px;\n\tfont-weight: 500;\n}\n\n.autoAffixBarList::after {\n\tcontent: '';\n\tdisplay: block;\n\twidth: 5px;\n\theight: 5px;\n\tbackground-color: var(--primary-foreground);\n\tborder-radius: 50%;\n}\n\n.scrollAffixBarListWrapper>li:last-child .autoAffixBarList::after {\n\tdisplay: none;\n}\n\n.isActiveAutoAffixBarList,\n.isActiveAutoAffixBarList:hover,\n.isActiveAutoAffixBarList:focus {\n\tcolor: var(--primary-foreground);\n\tfont-weight: 600;\n}\n\n@media (min-width:1200px) {\n\t.activeStickyBar {\n\t\tposition: sticky;\n\t\ttop: 0;\n\t\tz-index: 5;\n\t\tvisibility: visible;\n\t}\n\n\t.nonActiveStickyBar {\n\t\tvisibility: hidden;\n\t\theight: 0;\n\t\twidth: 0;\n\t}\n\n\t.activeStickyBarWrapper {\n\t\tmargin-top: -65px;\n\t}\n}\n\n@media (max-width:1199px) {\n\n\t.activeStickyBar,\n\t.nonActiveStickyBar {\n\t\tdisplay: none;\n\t}\n}\n\n@media (max-width: 1200px) and (min-width: 992px) {\n\n\t.similarPaddingText h2 {\n\t\tmargin-bottom: 20px;\n\t}\n}\n\n@media screen and (max-width: 991px) {\n\t.sliderMargin {\n\t\tpadding-bottom: 70px;\n\t\tmargin-bottom: 30px;\n\t}\n\n\t.similarPaddingText h2 {\n\t\tmargin-bottom: 20px;\n\t}\n\n}\n\n\n@media screen and (max-width: 767px) {\n\t.listingIntroSection {\n\t\tpadding-top: 0px;\n\t\tmargin-top: 0;\n\t}\n\n\t.sliderMargin {\n\t\tpadding-bottom: 100px;\n\t}\n\n\t.stickyBookButton {\n\t\tdisplay: block;\n\t}\n\n\t.displayBlockMobile {\n\t\tdisplay: block;\n\t}\n\n\t.displayTableMobile {\n\t\twidth: auto;\n\t}\n\n\t.webDevice {\n\t\tdisplay: block !important;\n\t}\n\n\t.filtersFooter {\n\t\twidth: 100%;\n\t\tdisplay: block;\n\t}\n\n\t.similarPaddingText h2 {\n\t\tmargin-bottom: 20px;\n\t}\n\n\t.loaderMobileView {\n\t\tmin-height: 100vh;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t}\n}\n\n\n@media screen and (min-width: 641px) {\n\t.webDevice {\n\t\tdisplay: block !important;\n\t}\n}\n\n@media screen and (max-width: 355px) {\n\t.responsiveNopadding {\n\t\tpadding: 0px !important;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `ViewListing-space1-YfDPJ`,
	"space2": `ViewListing-space2-PajrY`,
	"space3": `ViewListing-space3-Yq_oO`,
	"space4": `ViewListing-space4-Gd2qy`,
	"space5": `ViewListing-space5-Ccatq`,
	"space6": `ViewListing-space6-jvdeI`,
	"space7": `ViewListing-space7-I0bpA`,
	"spaceTop8": `ViewListing-spaceTop8-JMMMS`,
	"spaceTop1": `ViewListing-spaceTop1-lUohg`,
	"spaceTop2": `ViewListing-spaceTop2-wpEcC`,
	"spaceTop3": `ViewListing-spaceTop3-G9MbV`,
	"spaceTop4": `ViewListing-spaceTop4-x2Bx5`,
	"spaceTop5": `ViewListing-spaceTop5-Mcuvc`,
	"spaceTop6": `ViewListing-spaceTop6-tHCby`,
	"spaceTop7": `ViewListing-spaceTop7-BgrJA`,
	"noMargin": `ViewListing-noMargin-yaamJ`,
	"padding1": `ViewListing-padding1-SNPZw`,
	"padding2": `ViewListing-padding2-qJuAY`,
	"padding3": `ViewListing-padding3-trS80`,
	"padding4": `ViewListing-padding4-QXKn8`,
	"padding5": `ViewListing-padding5-jdMiO`,
	"padding6": `ViewListing-padding6-Kaqaw`,
	"padding7": `ViewListing-padding7-OOd0f`,
	"paddingTop1": `ViewListing-paddingTop1-GM3b3`,
	"paddingTop2": `ViewListing-paddingTop2-ZcGvJ`,
	"paddingTop3": `ViewListing-paddingTop3-USvES`,
	"paddingTop4": `ViewListing-paddingTop4-b0Pxe`,
	"paddingTop5": `ViewListing-paddingTop5-WCSIu`,
	"paddingTop6": `ViewListing-paddingTop6-yFbT1`,
	"paddingTop7": `ViewListing-paddingTop7-p1Mfn`,
	"noPadding": `ViewListing-noPadding-wz8Rz`,
	"textBold": `ViewListing-textBold-bQ8aE`,
	"textBolder": `ViewListing-textBolder-BOXzk`,
	"textNormal": `ViewListing-textNormal-XfJru`,
	"spaceBottom20": `ViewListing-spaceBottom20-Y7w_R`,
	"spaceBottom10": `ViewListing-spaceBottom10-vchNm`,
	"marginNone": `ViewListing-marginNone-fxpem`,
	"spaceBottom15": `ViewListing-spaceBottom15-zTh3k`,
	"marginTopNone": `ViewListing-marginTopNone-VTQHM`,
	"spaceTop11": `ViewListing-spaceTop11-idYzr`,
	"spaceTop21": `ViewListing-spaceTop21-jZT3F`,
	"spaceTop20": `ViewListing-spaceTop20-HCItB`,
	"spaceTop10": `ViewListing-spaceTop10-JE3m8`,
	"textDarkBlue": `ViewListing-textDarkBlue-sarDD`,
	"textLightBlue": `ViewListing-textLightBlue-DZ6cG`,
	"textLightSandleGreen": `ViewListing-textLightSandleGreen-NoVXa`,
	"textLightBrown": `ViewListing-textLightBrown-Rcd6a`,
	"textMediumMaroon": `ViewListing-textMediumMaroon-JL8r6`,
	"textBrown": `ViewListing-textBrown-HZi_Q`,
	"textMaroon": `ViewListing-textMaroon-IxQ40`,
	"textDarkBrown": `ViewListing-textDarkBrown-AUrtZ`,
	"textMediumBrown": `ViewListing-textMediumBrown-JxUUj`,
	"textSkyBlue": `ViewListing-textSkyBlue-veTWH`,
	"textGray": `ViewListing-textGray-QbcYf`,
	"root": `ViewListing-root-DTWn_`,
	"container": `ViewListing-container-sUPB7`,
	"pageContainer": `ViewListing-pageContainer-S945X`,
	"pageContent": `ViewListing-pageContent-uF7st`,
	"horizontalLineThrough": `ViewListing-horizontalLineThrough-zQ0oL`,
	"positionSticky": `ViewListing-positionSticky-dhZW3`,
	"similarPadding": `ViewListing-similarPadding-YMK_A`,
	"similarPaddingText": `ViewListing-similarPaddingText-oVZDs`,
	"showAffix": `ViewListing-showAffix-_rm81`,
	"textColor": `ViewListing-textColor-E5O7H`,
	"displayTable": `ViewListing-displayTable-K5UAz`,
	"displayTableCell": `ViewListing-displayTableCell-l3rqV`,
	"sectionTitleText": `ViewListing-sectionTitleText-oQbHh`,
	"stickyBookButton": `ViewListing-stickyBookButton-FmtQM`,
	"filtersFooter": `ViewListing-filtersFooter-ATPVv`,
	"filtersContainer": `ViewListing-filtersContainer-IdsfO`,
	"footerContainer": `ViewListing-footerContainer-du_wS`,
	"bookItPriceAmount": `ViewListing-bookItPriceAmount-1EDpF`,
	"bookItPrice": `ViewListing-bookItPrice-Auv2w`,
	"bookItNight": `ViewListing-bookItNight-mxHRY`,
	"fullWidth": `ViewListing-fullWidth-pzJO1`,
	"btn": `ViewListing-btn-NR3vM`,
	"reviewSection": `ViewListing-reviewSection-zDVDq`,
	"noBorder": `ViewListing-noBorder-Vtiau`,
	"instantIcon": `ViewListing-instantIcon-RYNzP`,
	"viewListingLoder": `ViewListing-viewListingLoder-mmr9h`,
	"viewListingMobileViewBook": `ViewListing-viewListingMobileViewBook-MFniJ`,
	"scrollAffixBarListWrapper": `ViewListing-scrollAffixBarListWrapper-H3zxG`,
	"autoAffixBarList": `ViewListing-autoAffixBarList-XjiAv`,
	"isActiveAutoAffixBarList": `ViewListing-isActiveAutoAffixBarList-oZW6G`,
	"activeStickyBar": `ViewListing-activeStickyBar-VpsPg`,
	"nonActiveStickyBar": `ViewListing-nonActiveStickyBar-_r_JJ`,
	"activeStickyBarWrapper": `ViewListing-activeStickyBarWrapper-vQw2I`,
	"sliderMargin": `ViewListing-sliderMargin-VkfEI`,
	"listingIntroSection": `ViewListing-listingIntroSection-Jmukh`,
	"displayBlockMobile": `ViewListing-displayBlockMobile-FWQHT`,
	"displayTableMobile": `ViewListing-displayTableMobile-ZhiWf`,
	"webDevice": `ViewListing-webDevice-mghDG`,
	"loaderMobileView": `ViewListing-loaderMobileView-FrNgc`,
	"responsiveNopadding": `ViewListing-responsiveNopadding-jH_lx`
};
module.exports = ___CSS_LOADER_EXPORT___;
